import { useCallback, useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';

import { GridCellProps } from '@progress/kendo-react-grid';
import useBoolean from 'src/hooks/useBoolean';
import useRedirectBtn from 'src/hooks/useRedirectBtn';
import GridCellBase from '../../../components/GridCellBase';
import Button from '../../../components/design-system/Button';

const CreateNewReceipt = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { onCreateNewClick, openNewTab = true } = cellClick?.(null);
  const RedirectButton = useRedirectBtn(false, openNewTab);
  const { value: isLoading, setTrue: startLoading, setFalse: endLoading } = useBoolean();

  const handleCreateNewClick = useCallback(async () => {
    startLoading();
    await onCreateNewClick(props.dataItem);
    endLoading();
  }, [endLoading, onCreateNewClick, props.dataItem, startLoading]);

  if (props.dataItem.receiptId === 1) {
    return (
      <GridCellBase {...props} rowSelectionEnabled={false} disableToolTip>
        <></>
      </GridCellBase>
    );
  }

  if (props.dataItem.receiptId === 0) {
    return (
      <GridCellBase
        {...props}
        className="flex justify-center"
        rowSelectionEnabled={false}
        disableToolTip
      >
        <Button
          color="secondary"
          onClick={handleCreateNewClick}
          loading={isLoading}
          className="m-auto"
        >
          Create New
        </Button>
      </GridCellBase>
    );
  }
  return <RedirectButton {...props} />;
};

export default CreateNewReceipt;
